import { SkeletonTheme } from 'react-loading-skeleton'
import { LOCATION_STATES } from './utils/constants'
import { isIos, isMobile } from './utils/isMobile'
import { checkIsNativeApp } from 'utils/nativeApp'
import 'react-loading-skeleton/dist/skeleton.css'
import * as nativeApp from './utils/nativeApp'
import AppLogin from './containers/AppLogin'
import { isDay } from './utils/sunPosition'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateTheme } from './appSlice'
import './App.scss'

const ios = isIos()
const mobile = isMobile()

const App = ({ children }) => {
  const [isLogIn, logIn] = useState(!process.env.REACT_APP_PASSWORD || checkIsNativeApp())

  const dispatch = useDispatch()

  useEffect(() => {
    if (nativeApp.checkIsNativeApp() && window.__NATIVE_APP__?.theme) {
      dispatch(updateTheme({
        mode: window.__NATIVE_APP__.theme.mode,
        lightTheme: window.__NATIVE_APP__.theme.value === 'light',
      }))
    } else {
      dispatch(updateTheme({ mode: 'auto', lightTheme: isDay() }))
    }
  }, [dispatch])

  useEffect(() => {
    const { href, origin } = window.location
    const homePath = `${origin}/`

    if (performance.getEntriesByType('navigation')[0].type !== 'reload') {
      window.history.replaceState(LOCATION_STATES.lastPage, null, homePath)
      window.history.pushState(null, '', homePath)
      window.history.pushState(null, '', href)
    }
  }, [])

  useEffect(() => {
    const updateVH = () => {
      const vh = window.innerHeight * 0.01
      document.body.style.setProperty('--vh', `${vh}px`)
    }

    const popstate = () => {
      const { state } = window.history
      if (state === LOCATION_STATES.lastPage) window.history.go(1)
    }

    const orientationchange = () => {
      if (ios) window.scrollTo(0, 0)
    }

    window.addEventListener('popstate', popstate)
    window.addEventListener('orientationchange', orientationchange)
    if (mobile) {
      updateVH()
      window.addEventListener('resize', updateVH)
    }

    return () => {
      if (mobile) window.removeEventListener('resize', updateVH)
      window.removeEventListener('popstate', popstate)
      window.removeEventListener('orientationchange', orientationchange)
    }
  }, [])

  return (
    <div className={`app --${process.env.REACT_APP_TYPE || 'am'}${nativeApp.checkIsIos() ? ' --ios' : ''}`}>
      <SkeletonTheme
        baseColor='var(--skeleton-base)'
        highlightColor='var(--skeleton-highlight)' >
        {isLogIn ? children : <AppLogin login={logIn} />}
      </SkeletonTheme>
    </div>
  )
}

export default App
